import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import ArrowSearch from "../../../assets/images/search-arrow.svg";
import LayoutContext from "../../../contexts/LayoutContext";
import { useNavigate } from "react-router-dom";
/* #region CSS */
const StyledPage = styled.div`
    &.frame-295922508,
    &.frame-295922508 * {
        box-sizing: border-box;
    }
    &.frame-295922508 {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 16px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: absolute;
        top: 51px;
        width: 100%;
        z-index: 9;
    }
    .frame-2959225082 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922592 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .brands {
        color: #f7665f;
        text-align: left;
        font-family: var(--caption-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: 12px;
        line-height: 14px;
        font-weight: var(--caption-semibold-font-weight, 600);
        position: relative;
        align-self: stretch;
    }
    .frame-295922578 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .arrow-narrow-up-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922583 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922584 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922585 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922591 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .items {
        color: #f7665f;
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 12px;
        line-height: 14px;
        font-weight: 600;
        position: relative;
        align-self: stretch;
    }
    .frame-295922586 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922588 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right6 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922589 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right7 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922590 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right8 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-2959225912 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .arrow-narrow-up-right9 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .label-name {
        color: #8c8c8c;
    }
    @media (max-width: 992px) {
        &.frame-295922508 {
            top: 115px;
            width: calc(100% - 80px);
            margin-left: 15px;
        }
    }
`;
const StyledPageNotFound = styled.div`
    &.frame-295922593,
    &.frame-295922593 * {
        box-sizing: border-box;
    }
    &.frame-295922593 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-29-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        opacity: 0.4;
    }
    .there-are-no-brands-to-show-from-your-search {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var (--button-text-medium-regular-font-weight, 400);
        position: relative;
    }
    .btn-sm-fw {
        background: #272727;
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 166px;
        height: 30px;
        position: relative;
    }
    .frame-313494 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
/* #endregion */
export default function SearchWindow({ searchText, setSearchText, setShowSearchWindow, setOnFocusSearchBox, searchData }) {
    const { setShowFilterBox, setSelectedType } = useContext(LayoutContext);
    const navigate = useNavigate();
    const highlightText = (text, highlight) => {
        if (!highlight) return text;
        if (typeof text === "undefined") return text;
        const startIndex = text.toLowerCase().indexOf(highlight.toLowerCase());
        if (startIndex === 0) {
            return (
                <>
                    <span style={{ color: "#ffffff" }}>{text.substring(0, highlight.length)}</span>
                    {text.substring(highlight.length)}
                </>
            );
        }
        return text;
    };

    return (
        <StyledPage className="frame-295922508">
            <div className="frame-2959225082">
                <div className="frame-295922592">
                    <div className="brands">BRANDS</div>
                    {searchData?.brands.length ? (
                        searchData?.brands.slice(0, 4).map((brand, index) => (
                            <div
                                key={index}
                                className="frame-295922578"
                                onClick={() => {
                                    setSelectedType("Posts");
                                    setSearchText(brand?.title);
                                    setShowSearchWindow(false);
                                    setOnFocusSearchBox(false);
                                    setShowFilterBox(true);
                                    //navigate(`/search?brands=${brand?.id}`);

                                    const imageFilter = "Posts";
                                    const brands = [{ _id: brand?._id, name: brand?.title }];
                                    navigate("/search", {
                                        state: { imageFilter, brands }
                                    });
                                }}>
                                <span className="label-name">{highlightText(brand?.title, searchText)}</span>
                                <img className="arrow-narrow-up-right" src={ArrowSearch} alt={`arrow-narrow-up-right${index}.svg`} />
                            </div>
                        ))
                    ) : (
                        <NoDataFound type={"brands"} />
                    )}
                </div>

                <div className="frame-295922591">
                    <div className="items">ITEMS</div>
                    {searchData?.items.length ? (
                        searchData?.items.slice(0, 5).map((item, index) => (
                            <div
                                key={index}
                                className="frame-295922578"
                                onClick={() => {
                                    setSelectedType("Products");
                                    setSearchText(item?.title);
                                    setShowSearchWindow(false);
                                    setOnFocusSearchBox(false);
                                    setShowFilterBox(true);
                                    //navigate(`/search?product=${item?._id}`);
                                    const imageFilter = "Products";
                                    const products = [{ _id: item?._id, name: item?.title }];
                                    navigate("/search", {
                                        state: { imageFilter, products }
                                    });
                                }}>
                                <span className="label-name">{highlightText(item?.title, searchText)}</span>
                                <img className="arrow-narrow-up-right" src={ArrowSearch} alt={`arrow-narrow-up-right${index}.svg`} />
                            </div>
                        ))
                    ) : (
                        <NoDataFound type={"items"} />
                    )}
                </div>
            </div>
        </StyledPage>
    );
}
const NoDataFound = ({ type }) => {
    return (
        <StyledPageNotFound className="frame-295922593">
            <div className="frame-29-search">
                <div className="there-are-no-brands-to-show-from-your-search">There are no {type} to show from your search</div>
            </div>
        </StyledPageNotFound>
    );
};
